import { Box, Snackbar } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useKeycloak } from "@react-keycloak/web";
import { useAtom, useAtomValue } from "jotai";
import { selectAtom } from "jotai/utils";
import { noop } from "lodash";
import React, { FC, useEffect, useState } from "react";
import { REALTIME_TEMPLATE_DELETE_MESSAGE, TEMPLATE_EDITOR_MODAL_TEXTS } from "../../../constants";
import { baseAtom } from "../../../stores/jotai/base";
import { discoverySessionAtom } from "../../../stores/jotai/discovery-session";
import { setSelectedTemplate, templatesAtom } from "../../../stores/jotai/template/templates";
import { useGetTemplates } from "../../../tanstackQuery/queries/templates";
import MaterialModal from "../../app/material-modal";
import { TemplateEditor } from "./template-editor";
interface TemplateEditorModalProps {
    open: boolean;
    handleDialogClose?: Function;
    hideBackButton?: boolean;
    setBase?: Function;
}
const userAtom =  selectAtom(baseAtom, (base) => base.user)
const teamAtom =  selectAtom(baseAtom, (base) => base.team)
const orgAtom =  selectAtom(baseAtom, (base) => base.org)
const roleSnapshotAtom = selectAtom(baseAtom, (base) => base.roleSnapshot);

const TemplateEditorModal: FC<TemplateEditorModalProps> = (props) => {
    const { open, handleDialogClose, hideBackButton, setBase  } = props;
    const [savingTemplateChanges, setSavingTemplateChanges] =
        useState<boolean>(false);
    const [shouldBlockModalClose, setShouldBlockModalClose] =
        useState<boolean>(false);
    const [reflectRealtimeTemplateUpdate, setReflectRealtimeTemplateUpdate] =
      useState<boolean>(false);
    const [templateTitle,setTemplateTitle] =
      useState<string>("Template List");
    const [localError, setLocalError] = useState('');
    const discoverySession = useAtomValue(discoverySessionAtom);
    const [templateAtomState, setTemplatesAtomState] = useAtom(templatesAtom);
    const { keycloak } = useKeycloak();
    const [team] = useAtom(teamAtom);
    const [user] = useAtom(userAtom);
    const [org] = useAtom(orgAtom);
    const [roleSnapshot] = useAtom(roleSnapshotAtom);
    const { data: templateDetails } = useGetTemplates({ accessToken: keycloak.token }, { groupID:team?.groupID }, {enabled: !!(team?.groupID)})

    const theme = useTheme();

    useEffect(() => {
      const { selectedTemplateID } = templateAtomState;

      if (selectedTemplateID && templateDetails?.templates?.length > 0) {       
        const selectedTemplate = templateDetails?.templates?.find(template => template?.templateID === templateAtomState?.selectedTemplateID)
         
        setReflectRealtimeTemplateUpdate(true);
        setSelectedTemplate(setTemplatesAtomState, selectedTemplate || null);
        
        // If template is undefined then trigger action for template deletion
        if(!selectedTemplate && templateDetails?.templates?.length < 0) {
            setLocalError(REALTIME_TEMPLATE_DELETE_MESSAGE);

            // For home page close the modal as there is no back button
            if(hideBackButton) {
                handleDialogClose();
            }
        }
      }
    }, [templateDetails?.templates]);

    const savingIndicator = (
        <Box
            component="span"
            sx={{
                display: "inline-block",
                fontWeight: 400,
                fontSize: "13px",
                marginLeft: "16px",
                letterSpacing: "0.4px",
                color: "rgba(255, 255, 255, 0.6)",
                opacity: savingTemplateChanges ? 1 : 0,
                transition: "opacity 0.1s ease",
            }}
        >
            Saving Changes . . .
        </Box>
    );

    return (
      <React.Fragment>
        <MaterialModal
          title={
            <>
              {templateTitle}
              {savingIndicator}
            </>
          }
          open={open}
          handleDialogClose={() => {
            if (!shouldBlockModalClose) {
              handleDialogClose();
            }
          }}
          styleOverrides={{
            container: {
              "& .MuiDialog-paper": {
                width: "100%",
                minHeight: "500px",
                minWidth: "980px",
              },
              "& .MuiDialogContent-root": {
                padding: "10px 24px 24px 24px",
              },
            },
          }}
          closeButtonTooltip={
            shouldBlockModalClose
              ? TEMPLATE_EDITOR_MODAL_TEXTS.MODAL_HEADER.CLOSE_BUTTON
                  .EMPTY_TEMPLATE_NAME.TOOLTIP
              : TEMPLATE_EDITOR_MODAL_TEXTS.MODAL_HEADER.CLOSE_BUTTON.NORMAL
                  .TOOLTIP
          }
          disableClose={shouldBlockModalClose}
        >
          <TemplateEditor
            templates={templateDetails?.templates}
            filteredTemplatesUsers={templateDetails?.users}
            discoverySession={discoverySession}
            loadTemplateData={() => {}}
            savingTemplate={false}
            user={user}
            org={org}
            team={team}
            setBase={setBase}
            isTeamMember={roleSnapshot?.isTeamMember}
            templateAtomState={templateAtomState}
            setTemplateAtomState={setTemplatesAtomState}
            hideBackButton={hideBackButton}
            closeTemplateView={() => {}}
            refreshTemplateList={() => {}}
            shouldBlockModalClose={shouldBlockModalClose}
            setSavingTemplateChanges={setSavingTemplateChanges}
            setShouldBlockModalClose={setShouldBlockModalClose}
            setReflectRealtimeTemplateUpdate={setReflectRealtimeTemplateUpdate}
            reflectRealtimeTemplateUpdate={reflectRealtimeTemplateUpdate}
            theme={theme}
            setTemplateTitle={setTemplateTitle}
          />
        </MaterialModal>
        <Snackbar
          anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
          open={!!localError}
          autoHideDuration={6000}
          onClose={() => {
            setLocalError("");
          }}
          message={localError}
        />
      </React.Fragment>
    );
};

TemplateEditorModal.defaultProps = {
    handleDialogClose: noop,
};

export default TemplateEditorModal;
